<div class="flex flex-column align-items-center justify-content-center animate-fade-in" style="min-height: 100dvh; padding: 2rem">
  <div class="animate-scale-in" style="width: 400px">
    <div
      class="card-modern p-5 mb-5"
      style="background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-light) 100%); width: 100%"
    >
      <img
        alt="OAK Events Logo"
        class="mb-0"
        style="max-width: 100%; height: auto; filter: brightness(0) invert(1)"
        src="assets/logo-oak-events-com.png"
        (touchstart)="onTouchStart()"
        (touchend)="onTouchEnd()"
        (mousedown)="onTouchStart()"
        (mouseup)="onTouchEnd()"
        (mouseleave)="onTouchEnd()"
      />
    </div>
  </div>

  <div class="animate-slide-up" style="animation-delay: 0.2s; width: 400px">
    <a [routerLink]="getRouterLink()" [replaceUrl]="true" class="block no-underline">
      <div class="card-modern shadow-hover p-5 cursor-pointer" style="width: 100%">
        <div class="flex align-items-center justify-content-center gap-3">
          <div
            class="w-3rem h-3rem border-circle flex align-items-center justify-content-center shadow-soft"
            style="background-color: var(--primary-color)"
          >
            <i class="pi pi-sign-in text-white text-xl"></i>
          </div>
          <div>
            <h3 class="m-0 text-xl font-bold">Start Check-In</h3>
            <p class="m-0 text-sm text-color-secondary mt-1">Begin your event check-in process</p>
          </div>
          <i class="pi pi-angle-right text-2xl text-color-secondary"></i>
        </div>
      </div>
    </a>
  </div>
</div>

<p-toast position="bottom-center" key="update" styleClass="modern-toast"></p-toast>
